import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { selectUser, setUser } from "../../../core/auth/authSlice";
import { addErrorMessage } from "../../../core/errors/errorSlice";
import { MembersApiRoutes } from "../../../shared/api-routes/member/members-api.routes";
import { ProfilePictureApiRoutes } from "../../../shared/api-routes/member/profile-picture.api-routes";
import { User } from "../../../shared/models";
import http from "../../../shared/utils/http";
import "./CompleteProfilePicture.scss";
import SelectProfilePicture from "./SelectProfilePicture";

const CompleteProfilePicture: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { actorId } = useSelector(selectUser) as User;
  const [loading, setLoading] = useState(false);

  const completeProfile = async () => {
    await http.post(MembersApiRoutes.COMPLETE_PROFILE(actorId));
    dispatch(setUser({ profileCompleted: true }));
    navigate("/board");
  };

  // Final Save — send the blob via Axios as FormData
  const handleFinalSave = async (croppedBlob: any) => {
    if (!croppedBlob || loading) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("profilePicture", croppedBlob, "profile.png");

    try {
      const res = await http.post(
        ProfilePictureApiRoutes.ADD_PROFILE_PIC(actorId),
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      dispatch(setUser({ avatarVersion: res.avatarVersion }));
      await completeProfile();
    } catch (err: any) {
      dispatch(
        addErrorMessage({
          title: t(
            "profile.profileImage.uploadError",
            "Failed to upload profile picture. Please try again."
          ),
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const skipProfilePic = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await completeProfile();
    } catch (err: any) {
      dispatch(
        addErrorMessage({
          title: t(
            "profile.completeProfile.error",
            "Failed to complete profile. Please try again."
          ),
        })
      );
      setLoading(false);
    }
  };

  return (
    <div className="complete-picture-container">
      {/* aggiunto  mewssaggio per utente di inserire immagine profilo*/}
      {/*da inserire anche un bottone per skippare lo step*/}
      <p className="sign-up-info__caption-title text-white">
        {t("profile.profileImage.title")}
      </p>
      <p className="sign-up-info__caption-subtitle">
        {t("profile.profileImage.subtitle")}
      </p>
      <SelectProfilePicture onSave={handleFinalSave} />
      <div
        style={{
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <p>-- or -- </p>
        <button
          className="btn btn-primary"
          onClick={skipProfilePic}
          disabled={loading}
        >
          {loading ? t("common.loading", "Loading...") : t("common.skip", "skip")}
        </button>
        <p>(you can always set it later)</p>
      </div>
    </div>
  );
};

export default CompleteProfilePicture;
